<template>
    <div class="app" style="height: 100%;">
        <div class="titleButton">
            <EqButton style="width: 90px; height: 34px; border-top-left-radius: 50px; border-bottom-left-radius: 50px;"
                name="待开票"></EqButton>
            <EqButton style="width: 90px; height: 34px; border-radius: 0px;" name="开票中"></EqButton>
            <EqButton
                style="width: 90px; height: 34px; border-top-right-radius: 50px; border-bottom-right-radius: 50px;"
                name="已开票"></EqButton>
        </div>
        <div style="margin-left: 20px;">
            <van-checkbox-group v-model="checked" bind:change="onChange">
                <van-checkbox name="a" shape="square">
                    <EqInvoicingDetails style="width: 330px; margin-left: 5px;">
                    </EqInvoicingDetails>
                </van-checkbox>
                <van-checkbox name="b" shape="square">
                    <EqInvoicingDetails style="width: 330px; margin-left: 5px;">
                    </EqInvoicingDetails>
                </van-checkbox>
            </van-checkbox-group>
        </div>
        <EqCell title="装修施工人员详情" @click.native="viewApplicationDetails('1')"></EqCell>
        <EqCell title="租户人员详情" @click.native="viewApplicationDetails('2')"></EqCell>
        <div style="text-align: center; position: fixed; bottom: 10px;">
            <EqButton style="width: 269px; height: 44px; margin-left: 25%;" name="立即开票"></EqButton>
        </div>
    </div>
</template>
<script>

import EqCell from "@/components/Commons/EqCell";
import EqButton from "@/components/Commons/EqButton";
import EqInvoicingDetails from "@/components/Commons/EqInvoicingDetails";
import { Checkbox, CheckboxGroup, } from 'vant';

export default {
    name: "applyForInvoicing",
    components: {
        EqButton, "van-checkbox": Checkbox, "van-checkbox-group": CheckboxGroup, EqInvoicingDetails, EqCell,
    },
    props: {

    },
    data() {
        return {
            checked: undefined,
        };
    },
    created() {

    },
    computed: {
    },
    methods: {
        viewApplicationDetails(row){
            if(row === '1'){
                //装修施工人员申请详情
                this.$router.push({ path: '/decorationPersonnelApplicationDetails' });
            }else{
                //租户人员申请详情
                this.$router.push({ path: '/tenantPersonnelApplicationDetails' });
            }
        },

    },
};
</script>
<style scoped>
.titleButton {
    text-align: center;
    margin-top: 20px;
}
</style>
  